import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslations from './locales/en.json';
import arTranslations from './locales/ar.json';

// Ensure i18n is always initialized from localStorage language
const initialLang = localStorage.getItem('i18nextLng') || 'en';
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: enTranslations,
            },
            ar: {
                translation: arTranslations,
            },
        },
        lng: initialLang,
        fallbackLng: 'en',
        debug: process.env.NODE_ENV === 'development',
        returnObjects: true,
        interpolation: {
            escapeValue: false, // React already escapes values
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
    });

export default i18n; 